import * as React from "react";

import { cn } from "@/lib/utils";

interface InputProps extends React.ComponentProps<"input"> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

function Input({
  className,
  type,
  startIcon,
  endIcon,
  disabled,
  ...props
}: InputProps) {
  return (
    <div className="relative flex items-center w-full">
      {/* Start Icon */}
      {startIcon && (
        <span className="absolute left-3 text-gray-400">{startIcon}</span>
      )}
      <input
        type={type}
        data-slot="input"
        className={cn(
          "border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[1px] focus-visible:ring-black",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive h-[40px] placeholder-g-100",
          startIcon ? "pl-7" : "", // Add padding if startIcon exists
          endIcon ? "pr-7" : "", // Add padding if endIcon exists
          disabled ? "text-g-400 cursor-not-allowed" : "",
          className
        )}
        disabled={disabled}
        {...props}
        placeholder={disabled ? "" : props.placeholder}
      />
      {/* End Icon */}
      {endIcon && (
        <span className="absolute right-3 text-gray-400">{endIcon}</span>
      )}
    </div>
  );
}

export { Input };
